module.exports = __webpack_public_path__ + "images/a21ea7e607dc1bd13434f52c70558a6b.png";